import React from "react";
import styled from "styled-components";
import { useTranslate } from '@tolgee/react';

import SettingsElementWithArrow from "./SettingsElementWithArrow";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";

const HelpSettings = () => {
  const navigateToLandingPageLink = (to) => {
    let url = "http://emotii.ai";
    window.open(`${url}/${to}`);
  };
  const handleSupportClick = (e) => {
    e.preventDefault();
    window.location = "mailto:support@emotii.ai";
  };
  const { t } = useTranslate();
  return (
    <Container>
      <Header>
        <HeaderTitle>{t('settings.help')}</HeaderTitle>
      </Header>
      <ContentWrapper>
        <Content>
          <GroupSubtitle>
            {t('settings.help_description')}
          </GroupSubtitle>
          <GroupContentWrapper>
            <SettingsElementWithArrow
              text={t('profile.term_and_conditions')}
              onClick={() => navigateToLandingPageLink("terms")}
            />
            <Separator />
            <SettingsElementWithArrow
              text={t('profile.privacy')}
              onClick={() => navigateToLandingPageLink("privacy")}
            />
            <Separator />
            <SettingsElementWithArrow
              text={t('profile.support')}
              onClick={(e) => handleSupportClick(e)}
            />
          </GroupContentWrapper>
        </Content>
      </ContentWrapper>
    </Container>
  );
};

export default HelpSettings;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 19px 16px;
  align-items: center;
  background: ${({ theme }) => theme.menu.background};
  border-bottom: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  gap: 20px;
`;
const HeaderTitle = styled.h3`
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.04px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  background: ${({ theme }) => theme.menu.background};
  height: 100%;
  overflow: auto;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin: 0 auto;
  max-width: 631px;
  width: 100%;
`;
const GroupSubtitle = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.04px;
  vertical-align: middle;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
`;
const GroupContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px;
  padding: 0 16px;
`;

const Separator = styled.div`
  display: flex;
  width: 100%;
  min-height: 1px;
  background: ${({ theme }) => theme.sidebar.borderColor};
`;
